// JS.
import {IconicPanels} from './modules/panels.js';
import {IconicSliders} from './modules/sliders.js';
import {IconicMegamenu} from './modules/megamenu.js';
import {IconicSticky} from './modules/sticky.js';
import {IconicCheckout} from './modules/checkout.js';
import {IconicAccordion} from './modules/accordion.js';
import {IconicModal} from './modules/modal.js';

/**
 * On doc ready.
 */
document.addEventListener( "DOMContentLoaded", () => {
	new IconicPanels();
	new IconicSliders();
	new IconicMegamenu();
	new IconicSticky();
	new IconicCheckout();
	new IconicAccordion();
	new IconicModal();
} );